const apiAddress = `${process.env.REACT_APP_API_URL}/resources`;

class Api {
    static async get(endpoint, params = {}) {
        let urlParameters = Object.entries(params).map(p => p.join('=')).join('&');
        urlParameters = urlParameters + "&mmeToken=";
        const response = await fetch(`${apiAddress}/${endpoint}?${urlParameters}`);
        return await response.json();
    }
    static async post(endpoint, params = {}) {
        const response = await fetch(`${apiAddress}/${endpoint}`, {
            body: JSON.stringify({
                ...params,
                mmeToken: ''
            }),
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        return await response.json();
    }
}

export default Api;